import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowMidUp = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M37.721 19.85 24 6.129 10.278 19.85l2.121 2.121 10.101-10.1V39.75h3V11.871l10.1 10.1z" }) }) })
});
export default SvgArrowMidUp;
